import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { generateMergeSuggestions } from '../common/Helpers';
import { useTranslation } from 'react-i18next';

const MergeStudentsSection = ({ studentsA, studentsB, suggestions, onSuggestionChange }) => {
  const { t: tr } = useTranslation();
  const mergeSuggestions = useMemo(() => generateMergeSuggestions(studentsA, studentsB),
    [studentsA, studentsB]);

  const handleSuggestionToggle = (studentBId) => {
    const current = (suggestions[studentBId] || {}).merge || false;
    const suggestion = mergeSuggestions.find(s => s.studentB.id === studentBId);
    onSuggestionChange(studentBId, {
      merge: !current,
      mergeWith: !current && suggestion ? suggestion.studentA.id : null,
    });
  };

  const isMerging = (studentBId) => (suggestions[studentBId] || {}).merge || false;

  return (
    <div className="merge-students-section">
      <h5>{tr("manage:studentsToMerge_256")}</h5>
      <p className="text-muted small">{tr("manage:theSystemSuggestsMergingStudentsWithTheSameFirst_257")}</p>

      {mergeSuggestions.length === 0 && studentsB.length === 0 && (
        <p className="text-muted">{tr("manage:noStudentsToTransfer_258")}</p>
      )}

      <div className="list-group">
        {mergeSuggestions.map(suggestion => (
          <div key={suggestion.studentB.id} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <strong className="text-primary">
                {suggestion.studentA.firstName} {suggestion.studentA.lastName || ''} {tr("manage:fromA_259")}</strong>
              {' + '}
              <strong className="text-secondary">
                {suggestion.studentB.firstName} {suggestion.studentB.lastName || ''} {tr("manage:fromB_260")}</strong>
              {suggestion.studentA.additionalInfo && suggestion.studentB.additionalInfo && (
                <small className="text-muted d-block mt-1">{tr("manage:details_261")} {suggestion.studentA.additionalInfo} + {suggestion.studentB.additionalInfo}
                </small>
              )}
            </div>
            <button
              type="button"
              className={`btn btn-sm ${isMerging(suggestion.studentB.id) ? 'btn-success' : 'btn-outline-primary'}`}
              onClick={() => handleSuggestionToggle(suggestion.studentB.id)}
            >
              {isMerging(suggestion.studentB.id) ? tr("manage:willBeMerged_262") : tr("manage:willNotBeMerged_263")}
            </button>
          </div>
        ))}

        {studentsB
          .filter(studentB => !mergeSuggestions.find(s => s.studentB.id === studentB.id))
          .map(student => (
            <div key={student.id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong className="text-secondary">
                  {student.firstName} {student.lastName || ''} {tr("manage:onlyFromB_264")}</strong>
                {student.additionalInfo && (
                  <small className="text-muted d-block mt-1">{tr("manage:details_261")} {student.additionalInfo}
                  </small>
                )}
              </div>
              <span className="badge bg-secondary">{tr("manage:transferToA_265")}</span>
            </div>
          ))
        }
      </div>
    </div>
  );
};

MergeStudentsSection.propTypes = {
  studentsA: PropTypes.array.isRequired,
  studentsB: PropTypes.array.isRequired,
  suggestions: PropTypes.object.isRequired,
  onSuggestionChange: PropTypes.func.isRequired,
};

export default MergeStudentsSection;
